import { render } from "./message-timeout-warning.vue?vue&type=template&id=1f2e94e4&ts=true"
import script from "./message-timeout-warning.vue?vue&type=script&lang=ts"
export * from "./message-timeout-warning.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__